<div class="login-hero validate-hero">
  <div class="login-backdrop"></div>
  <div class="login-card validate-card">
    <div class="validate-card__content">
      <img
        src="assets/images/img-01.png"
        alt="TBAGROSENSOR"
        class="validate-logo"
      />
      <h2 class="validate-title">Verificación de cuenta</h2>
      <p
        class="validate-message"
        [class.is-success]="status === 'success'"
        [class.is-error]="status === 'error'"
      >
        {{ message }}
      </p>
    </div>
  </div>
</div>
